import {useState, useEffect} from "react";
import { getGifs } from "../helpers/getGifs";

export const useFetchGifs = (category) => {
    const [images, setImages] = useState([]);
    const [loading, setIsLoading] = useState(true);
	const getImages = async() => {
		const newImages = await getGifs(category);
		setImages(newImages);
        setIsLoading(false);
	}

	useEffect(() => {
		getImages();
	}, []);

    return {
        images,
        loading
    }
}
